var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearchlight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    rx: 9,
    fill: "#B2B2B2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8264 12.7649L11.7237 11.6622M11.7237 11.6622C12.0733 11.3126 12.3506 10.8976 12.5398 10.4408C12.729 9.98406 12.8264 9.49451 12.8264 9.00011C12.8264 8.50572 12.729 8.01616 12.5398 7.5594C12.3506 7.10264 12.0733 6.68761 11.7237 6.33802C11.3741 5.98843 10.9591 5.71112 10.5023 5.52193C10.0456 5.33273 9.55603 5.23535 9.06163 5.23535C8.56724 5.23535 8.07769 5.33273 7.62092 5.52193C7.16416 5.71112 6.74914 5.98843 6.39955 6.33802C5.69352 7.04405 5.29687 8.00164 5.29688 9.00011C5.29688 9.99859 5.69352 10.9562 6.39955 11.6622C7.10558 12.3682 8.06316 12.7649 9.06163 12.7649C10.0601 12.7649 11.0177 12.3682 11.7237 11.6622Z",
    stroke: "white",
    strokeWidth: 1.05882,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchlight);
export default __webpack_public_path__ + "static/media/searchlight.463abfa45c510114e6cf3bb368e8bb74.svg";
export { ForwardRef as ReactComponent };